import { useAtomValue } from 'jotai';

import { performanceTierAtom } from '@/atoms/performanceTier';
import { PerformanceTier } from '@/utils/performanceTier';

/**
 * The company's Performance tier, and whether it holds Performance PRO. Surfaces hidden from every
 * role short of PRO (milestones, communication blocks, filters, badges) only need `isPro`; access
 * points that can be shown locked go through `useProGate`.
 */
export const usePerformanceTier = () => {
    const tier = useAtomValue(performanceTierAtom);

    return { tier, isPro: tier === PerformanceTier.Pro };
};
